import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { MenusProvider as Provider } from '@shapeable/ui';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const MENUS_QUERY = graphql`
query NodeAllMenusQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Menus" } }) {
    nodes {
      data
    }
  }
}
`;

export const MenusProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(MENUS_QUERY), 'items')}>{children}</Provider>;
};
